export enum DataType {
  STRING = 'STRING',
  NUMBER = 'NUMBER',
  BOOLEAN = 'BOOLEAN',
  COORDINATES = 'COORDINATES',
  ANALOG_SIGNAL = 'ANALOG_SIGNAL',
  DIGITAL_SIGNAL = 'DIGITAL_SIGNAL'
}
